
// VAN HØLLEN — Shopify Theme JS
// Adapted from custom HTML build — birebir aynı tasarım

// ─── CART ───────────────────────────────────────────
function formatMoney(cents) {
  return '₺' + (cents / 100).toLocaleString('tr-TR', {minimumFractionDigits: 2});
}

async function updateCartUI() {
  const res = await fetch('/cart.js');
  const cart = await res.json();
  const countEl = document.getElementById('cartCount');
  if (countEl) {
    countEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
    countEl.textContent = cart.item_count;
  }
  const itemsEl = document.getElementById('cartItems');
  const footEl = document.getElementById('cartFoot');
  if (!itemsEl) return;
  if (cart.items.length === 0) {
    itemsEl.innerHTML = '<div class="cart-empty"><p>Sepetiniz boş.</p></div>';
    if (footEl) footEl.style.display = 'none';
    return;
  }
  itemsEl.innerHTML = cart.items.map(item => `
    <div class="cart-item">
      <img class="cart-item-img" src="${item.image}" alt="${item.product_title}">
      <div class="cart-item-info">
        <div class="cart-item-name">${item.product_title}</div>
        <div class="cart-item-size">${item.variant_title !== 'Default Title' ? 'Beden: ' + item.variant_title : ''}</div>
        <div class="cart-item-price">${formatMoney(item.line_price)}</div>
      </div>
      <button class="cart-item-remove" onclick="removeItem('${item.key}')">×</button>
    </div>
  `).join('');
  if (footEl) {
    footEl.style.display = 'block';
    const totalEl = document.getElementById('cartTotal');
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
  }
}

async function removeItem(key) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: {'Content-Type':'application/json'},
    body: JSON.stringify({id: key, quantity: 0})
  });
  updateCartUI();
}

function openCart() {
  document.getElementById('cartOverlay').classList.add('open');
  document.getElementById('cartDrawer').classList.add('open');
  document.body.style.overflow = 'hidden';
  updateCartUI();
}

function closeCart() {
  document.getElementById('cartOverlay').classList.remove('open');
  document.getElementById('cartDrawer').classList.remove('open');
  document.body.style.overflow = '';
}

// ─── PRODUCT PAGE ────────────────────────────────────
let selectedVariantId = null;

function switchImg(src, el) {
  document.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
  if (el) el.classList.add('active');
  const main = document.getElementById('mainProductImg');
  if (main) main.src = src;
}

function selectSize(btn, variantId) {
  document.querySelectorAll('.size-btn').forEach(b => b.classList.remove('selected'));
  btn.classList.add('selected');
  selectedVariantId = variantId;
  const atcBtn = document.getElementById('atcBtn');
  if (atcBtn) { atcBtn.disabled = false; atcBtn.textContent = 'Sepete Ekle'; }
}

async function addToCart() {
  if (!selectedVariantId) return;
  const atcBtn = document.getElementById('atcBtn');
  if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'Ekleniyor...'; }
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {'Content-Type':'application/json'},
    body: JSON.stringify({id: selectedVariantId, quantity: 1})
  });
  if (res.ok) {
    showToast('Sepete eklendi');
    await updateCartUI();
    setTimeout(() => openCart(), 300);
  }
  if (atcBtn) { atcBtn.disabled = false; atcBtn.textContent = 'Sepete Ekle'; }
}

// ─── ACCORDION ───────────────────────────────────────
function toggleAcc(btn) {
  const body = btn.nextElementSibling;
  const isOpen = body.classList.contains('open');
  document.querySelectorAll('.acc-body').forEach(b => b.classList.remove('open'));
  document.querySelectorAll('.acc-btn').forEach(b => b.classList.remove('open'));
  if (!isOpen) { body.classList.add('open'); btn.classList.add('open'); }
}

// ─── TOAST ───────────────────────────────────────────
function showToast(msg) {
  const t = document.getElementById('toast');
  if (!t) return;
  t.textContent = msg;
  t.classList.add('show');
  setTimeout(() => t.classList.remove('show'), 2200);
}

// ─── HOVER ZOOM ──────────────────────────────────────
function initHoverZoom(wrap) {
  if (!wrap) return;
  const img = wrap.querySelector('img');
  if (!img) return;
  const SCALE = 2.2;
  wrap.addEventListener('mousemove', e => {
    const rect = wrap.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    img.style.transformOrigin = x + '% ' + y + '%';
    img.style.transform = 'scale(' + SCALE + ')';
  });
  wrap.addEventListener('mouseleave', () => {
    img.style.transform = 'scale(1)';
    img.style.transformOrigin = 'center center';
  });
}

// ─── LIGHTBOX ────────────────────────────────────────
let lbImages = [], lbIndex = 0, lbZoomed = false, lbDragging = false;
let lbStartX, lbStartY, lbStartPosX = 0, lbStartPosY = 0;

function openLightbox(images, idx) {
  lbImages = images;
  lbIndex = idx;
  lbZoomed = false;
  document.getElementById('lightbox').classList.add('open');
  document.body.style.overflow = 'hidden';
  lbRender();
}

function closeLightbox() {
  document.getElementById('lightbox').classList.remove('open');
  document.body.style.overflow = '';
  lbZoomed = false;
  const img = document.getElementById('lbImg');
  if (img) { img.style.transform = 'scale(1)'; img.style.transformOrigin = 'center center'; }
}

function lbRender() {
  const img = document.getElementById('lbImg');
  const counter = document.getElementById('lbCounter');
  if (!img) return;
  img.src = lbImages[lbIndex];
  img.style.transform = 'scale(1)';
  img.style.transformOrigin = 'center center';
  img.style.maxWidth = '90vw';
  img.style.maxHeight = '90vh';
  lbZoomed = false;
  if (counter) counter.textContent = (lbIndex + 1) + ' / ' + lbImages.length;
  const dots = document.getElementById('lbThumbs');
  if (dots) {
    dots.innerHTML = lbImages.map((_,i) =>
      `<button class="lightbox-dot${i===lbIndex?' active':''}" onclick="lbGo(${i})"></button>`
    ).join('');
  }
}

function lbGo(idx) { lbIndex = idx; lbRender(); }
function lbPrev(e) { if(e)e.stopPropagation(); lbIndex = (lbIndex-1+lbImages.length)%lbImages.length; lbRender(); }
function lbNext(e) { if(e)e.stopPropagation(); lbIndex = (lbIndex+1)%lbImages.length; lbRender(); }

function lbToggleZoom(e) {
  if(e) e.stopPropagation();
  const img = document.getElementById('lbImg');
  if (!img) return;
  lbZoomed = !lbZoomed;
  if (lbZoomed) {
    img.style.maxWidth = 'none'; img.style.maxHeight = 'none';
    img.style.transform = 'scale(2.5)'; img.style.cursor = 'move';
  } else {
    img.style.maxWidth = '90vw'; img.style.maxHeight = '90vh';
    img.style.transform = 'scale(1)'; img.style.cursor = 'crosshair';
  }
}

function lbClickOutside(e) {
  if (e.target.id === 'lightbox' || e.target.id === 'lbImgWrap') {
    if (!lbZoomed) closeLightbox();
  }
}

// ─── COLLECTION FILTER ────────────────────────────────
function filterCollection(type, btn) {
  document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  document.querySelectorAll('.prod-card').forEach(card => {
    if (type === 'all' || (card.dataset.type && card.dataset.type.includes(type))) {
      card.style.display = 'block';
    } else {
      card.style.display = 'none';
    }
  });
}

// ─── INIT ─────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {
  updateCartUI();

  // Hover zoom on product main image
  const mainWrap = document.querySelector('.main-img-wrap');
  if (mainWrap) initHoverZoom(mainWrap);

  // Lightbox open on product image click
  if (mainWrap) {
    mainWrap.addEventListener('click', () => {
      const thumbs = Array.from(document.querySelectorAll('.product-thumb')).map(t => t.src);
      if (thumbs.length > 0) openLightbox(thumbs, 0);
    });
  }

  // Lightbox hover zoom
  const lbImg = document.getElementById('lbImg');
  if (lbImg) {
    lbImg.addEventListener('mousemove', e => {
      if (lbZoomed) return;
      const rect = lbImg.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      lbImg.style.transformOrigin = x + '% ' + y + '%';
      lbImg.style.transform = 'scale(2.2)';
    });
    lbImg.addEventListener('mouseleave', () => {
      if (lbZoomed) return;
      lbImg.style.transform = 'scale(1)';
      lbImg.style.transformOrigin = 'center center';
    });
    lbImg.addEventListener('mousedown', e => {
      if (!lbZoomed) return;
      e.preventDefault(); lbDragging = true;
      lbStartX = e.clientX; lbStartY = e.clientY;
      const m = lbImg.style.transform.match(/translate\(([^,]+)px,\s*([^)]+)px\)/);
      lbStartPosX = m ? parseFloat(m[1]) : 0;
      lbStartPosY = m ? parseFloat(m[2]) : 0;
    });
    document.addEventListener('mousemove', e => {
      if (!lbDragging || !lbZoomed) return;
      const dx = (e.clientX - lbStartX) / 2.5;
      const dy = (e.clientY - lbStartY) / 2.5;
      lbImg.style.transform = `scale(2.5) translate(${lbStartPosX+dx}px,${lbStartPosY+dy}px)`;
    });
    document.addEventListener('mouseup', () => { lbDragging = false; });
  }

  // Keyboard nav for lightbox
  document.addEventListener('keydown', e => {
    const lb = document.getElementById('lightbox');
    if (!lb || !lb.classList.contains('open')) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') lbPrev();
    if (e.key === 'ArrowRight') lbNext();
  });
});
